import { EditDialogHeaderButtons, Icon, Stack, StackProps, Typography } from "@tm/components"
import { useOwnArticlesStore } from "../store"

type HeaderProps = {
    headline: string
    onCloseButtonClick(): void
    sx?: StackProps["sx"]
}

export function EditDialogHeader({ headline, onCloseButtonClick, sx }: HeaderProps) {
    const { isSaving } = useOwnArticlesStore()

    return (
        <Stack direction="row" justifyContent="space-between" sx={sx}>
            <Stack direction="row" alignContent="center" gap={1}>
                <Icon name="individual-article" size="large" />
                <Typography variant="h2">{headline}</Typography>
            </Stack>
            <EditDialogHeaderButtons isSaving={isSaving} onCloseButtonClick={onCloseButtonClick} />
        </Stack>
    )
}
